import * as React from 'react';
import { useAdyen } from '../../../../../../context/Adyen/context.js';
import '../../../../../../context/PaymentsUI/context.js';
import '@swc/helpers';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { AdyenPaymentType } from '../../../../../../models/adyen/payment-type.js';
import { AdyenBrands, PaymentMethod } from '../../../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../../../models/googlePay/types.js';
import '../../../../../../models/payment/types.js';
import '../../../../../../models/paypal/context.js';
import { CreditCardContainer } from '../../../../containers/Adyen/CreditCard/CreditCardContainer.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/forms';

const Bancontact = ({ onChange , config: paymentConfig  })=>{
    const { config  } = useAdyen();
    const bancontactConfig = React.useMemo(()=>{
        const configData = config === null || config === void 0 ? void 0 : config.bancontactCard;
        if (configData && (paymentConfig === null || paymentConfig === void 0 ? void 0 : paymentConfig.brands)) {
            configData.brands = paymentConfig === null || paymentConfig === void 0 ? void 0 : paymentConfig.brands;
        }
        return configData;
    }, [
        config,
        paymentConfig
    ]);
    const handleChange = React.useCallback((state)=>{
        let paymentMethodType;
        if (state.cardBrand === AdyenBrands.VISA || state.cardBrand === AdyenBrands.MAESTRO) {
            paymentMethodType = PaymentMethod.CREDITCARD;
        }
        onChange(state.data, state.isValid, paymentMethodType);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(CreditCardContainer, {
        onChange: handleChange,
        additionalOptions: bancontactConfig,
        type: AdyenPaymentType.Bancontact
    });
};

export { Bancontact };
//# sourceMappingURL=Bancontact.js.map
